import React from "react";
import { Page, IconButton, If, Loadable } from "components/support";
import Typography from "material-ui-next/Typography";
import Dropzone from "./dropzone";
import DataTable from "./data-table";
import Progress from "./progress";
import LogsDialog from "./logs-dialog";

const EntryByXMLView = ({ presenter, viewModel }) => {
  const {
    loading,
    importStatusLoading,
    fileStatus,
    logsMessages,
    logsFields,
    products,
    sellableSearchOptions,
    page,
    import_permission,
    progress,
    logsDialogOpen,
    importSellableCode
  } = viewModel;

  return (
    <Loadable loading={loading || importStatusLoading}>
      <Page>
        <Typography type="display1" className="pb-sm">
          <IconButton icon="arrow_back" onClick={() => presenter.onGoBack()} />
          <span>Entrada por XML</span>
        </Typography>
        <If test={!import_permission}>
          <Progress progress={progress} />
        </If>
        <If test={import_permission}>
          <Dropzone
            loading={loading}
            status={fileStatus}
            onFileSelect={file => presenter.onFileSelect(file)}
          />
        </If>
        <If test={fileStatus === "valid"}>
          <DataTable
            products={products}
            importSellableCode={importSellableCode}
            sellableSearchOptions={sellableSearchOptions}
            onUpdateItem={(index, field, value) =>
              presenter.onUpdateItem(index, field, value)
            }
            onImport={() => presenter.onImport()}
            onCancel={() => presenter.onCancel()}
            onPageChange={page => presenter.onPageChange(page)}
            onImportSellableCodeChange={() => presenter.onImportSellableCodeChange()}
            page={page}
          />
        </If>
        <LogsDialog
          loading={loading}
          open={logsDialogOpen}
          onClose={() => presenter.onLogsDialogClose()}
          content={{ messages: logsMessages, fields: logsFields }}
        />
      </Page>
    </Loadable>
  );
};

export default EntryByXMLView;



// WEBPACK FOOTER //
// ./src/components/app/registration/product/inventory/modify/xml/view.jsx